/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_puedeAccion as puedeAccion,
  rec_Componente_dk_100_107 as Componente_dk_100_107,
  rec_DetalleTarea as DetalleTarea,
  rec_EstadoError as EstadoError,
  rec_HO as HO,
  rec_JSXRuntime as JSXRuntime,
  rec_Paginacion as Paginacion,
  rec_Qx as Qx,
  rec_React as React,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_TarjetaTarea as TarjetaTarea,
  rec_Ti as Ti,
  rec_UO as UO,
  rec_Xx as Xx,
  rec_Yx as Yx,
  rec_Zx as Zx,
  rec_api as api,
  rec_fC as fC,
  rec_fS as fS,
} from "../../runtime/index.jsx";
export function TareasUnidad({ unidadId: e, unidadNombre: t, sede: n }) {
  let [r, i] = (0, React.useState)(null),
    [a, o] = (0, React.useState)(!1),
    [s, c] = (0, React.useState)(`ABIERTAS`),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)(0),
    [g, _] = (0, React.useState)({
      items: [],
      total: 0,
    }),
    [v, y] = (0, React.useState)(!0),
    [b, x] = (0, React.useState)(``),
    S = (0, React.useCallback)(async () => {
      (y(!0), x(``));
      let t = UO.find((e) => e.value === s),
        r = new URLSearchParams({
          pagina: String(m),
          tamano: `15`,
        });
      (l && r.set(`desde`, l),
        f && r.set(`hasta`, f),
        t?.estados && r.set(`estados`, t.estados.join(`,`)),
        n && r.set(`sede`, String(n)));
      try {
        _(await api(`/unidades/${e}/tareas?${r.toString()}`));
      } catch (e) {
        x(e.message);
      } finally {
        y(!1);
      }
    }, [e, s, l, f, m, n]);
  ((0, React.useEffect)(() => {
    S();
  }, [S]),
    (0, React.useEffect)(() => fC(() => S()), [S]));
  let C = (e) => (t) => {
    (e(t), h(0));
  };
  return (
    <section
      className={`flex flex-col gap-2`}
      children={[
        <div
          className={`flex flex-wrap items-center justify-between gap-2`}
          children={[
            <p
              className={`text-sm font-medium text-(--text-h)`}
              children={`Tareas`}
            />,
            <div
              className={`flex flex-wrap items-center gap-2`}
              children={[
                puedeAccion(`planner.tareas.crear`, e) && (
                <button
                  type={`button`}
                  onClick={() => o(!0)}
                  className={HO}
                  children={[
                    <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                    ` Nueva tarea`,
                  ]}
                />),
                <div
                  className={`w-56`}
                  children={
                    <SelectorMultiple
                      value={s}
                      onChange={C(c)}
                      opciones={UO.map((e) => ({
                        value: e.value,
                        label: e.label,
                      }))}
                    />
                  }
                />,
                <div
                  className={`w-36`}
                  children={
                    <SelectorFecha
                      value={l}
                      placeholder={`Vencen desde`}
                      onChange={(e) => C(u)(e)}
                    />
                  }
                />,
                <div
                  className={`w-32`}
                  children={
                    <SelectorFecha
                      value={f}
                      placeholder={`hasta`}
                      min={l || void 0}
                      onChange={(e) => C(p)(e)}
                    />
                  }
                />,
                (l || f || s !== `ABIERTAS`) && (
                  <button
                    type={`button`}
                    onClick={() => {
                      (u(``), p(``), c(`ABIERTAS`), h(0));
                    }}
                    className={HO}
                    children={`Limpiar`}
                  />
                ),
              ]}
            />,
          ]}
        />,
        (l || f || s !== `ABIERTAS`) && (
          <p
            className={`text-xs text-(--text)`}
            children={`Esto filtra solo la lista — los números de arriba siguen siendo del área entera.`}
          />
        ),
        <EstadoError mensaje={b} onReintentar={S} />,
        v ? (
          <Componente_dk_100_107 />
        ) : g.items.length === 0 ? (
          <div
            className={`flex flex-col items-center gap-2 rounded-xl border border-dashed border-(--border) px-3 py-5 text-center`}
            children={[
              <p
                className={`text-sm text-(--text)`}
                children={
                  l || f || s !== `ABIERTAS`
                    ? `No hay tareas que cumplan con lo que estás filtrando.`
                    : `Acá no hay tareas abiertas.`
                }
              />,
              (l || f || s !== `ABIERTAS`) && (
                <button
                  type={`button`}
                  onClick={() => {
                    (u(``), p(``), c(`ABIERTAS`), h(0));
                  }}
                  className={HO}
                  children={`Sacar los filtros`}
                />
              ),
            ]}
          />
        ) : (
          <ul
            className={`animar-cascada flex flex-col gap-1.5`}
            children={g.items.map((e) => (
              <li
                key={e.id}
                children={
                  <button
                    type={`button`}
                    onClick={() => i(e.id)}
                    className={`flex w-full flex-wrap items-center gap-2 rounded-xl border border-(--border) px-3 py-2 text-left text-sm transition hover:bg-(--accent-bg)`}
                    children={[
                      <span
                        className={`min-w-0 flex-1 truncate text-(--text-h)`}
                        children={e.titulo}
                      />,
                      <span
                        className={`rounded-full border px-2 py-0.5 text-[10px] ${Zx(e.prioridad)}`}
                        children={Yx(e.prioridad)}
                      />,
                      <span
                        className={`rounded-full px-2 py-0.5 text-[10px] ${Qx(e.estado)}`}
                        children={Yx(e.estado)}
                      />,
                      Xx(e) && (
                        <span
                          className={`text-[11px] text-(--text)`}
                          children={Xx(e)}
                        />
                      ),
                      e.fechaVencimiento && (
                        <span
                          className={`text-[11px] ${e.atrasada ? `text-(--error)` : `text-(--text)`}`}
                          children={fS(e.fechaVencimiento)}
                        />
                      ),
                      <span
                        className={`text-[11px] text-(--text)`}
                        children={[`· `, e.proyectoNombre || e.unidadNombre]}
                      />,
                    ]}
                  />
                }
              />
            ))}
          />
        ),
        <Paginacion
          pagina={m}
          tamano={15}
          total={g.total}
          onChange={h}
          cargando={v}
        />,
        r && <TarjetaTarea tareaId={r} onClose={() => i(null)} onCambio={S} />,
        a && (
          <DetalleTarea
            proyecto={{
              id: null,
              unidadId: e,
              nombre: t,
              miRol: `COLABORADOR`,
              miembros: [],
            }}
            onClose={() => o(!1)}
            onGuardado={S}
          />
        ),
      ]}
    />
  );
}
